import { ActivityLogStatusNumber } from "./activity-log-status-number.constants";

export class ActivityLogStatusHierarchy {
	static ApprovedStatusNumbers: string[] = [ActivityLogStatusNumber.Approved];
	static VerifiedStatusNumbers: string[] = [ActivityLogStatusNumber.Verified, ...ActivityLogStatusHierarchy.ApprovedStatusNumbers];
	static SubmittedStatusNumbers: string[] = [ActivityLogStatusNumber.Submitted, ...ActivityLogStatusHierarchy.VerifiedStatusNumbers];
	static ReturnedStatusNumbers: string[] = [ActivityLogStatusNumber.Returned];
	static OpenStatusNumbers: string[] = [ActivityLogStatusNumber.Open];
}
